import Gate from '@/services/api/gate';

export default {
  state: {
    gates: [],
    gate: {},
    gateEdit: {},
  },
  getters: {
    gates: state => state.gates,
    gate: state => state.gate,
    gateEdit: state => state.gateEdit,
  },
  mutations: {
    setGates: (state, items) => {
      state.gates = items;
    },
    setGate: (state, item) => {
      state.gate = item;
    },
    setGateEdit: (state, item) => {
      state.gateEdit = item;
    },
  },
  actions: {
    newGate (state, gate) {
      return new Promise((resolve, reject) => {
        Gate.newGate(gate)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    massAddGateDoorphones (state, { gateId, doorphone_ids, apartment_prefixes, without_apartment_prefix }) {
      return new Promise((resolve, reject) => {
        Gate.massAddGateDoorphones(gateId, { doorphone_ids, apartment_prefixes, without_apartment_prefix })
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    addGateDoorphone (state, { gateId, doorphoneId, apartment_prefix, without_apartment_prefix }) {
      return new Promise((resolve, reject) => {
        Gate.addGateDoorphone(gateId, doorphoneId, { apartment_prefix, without_apartment_prefix })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteGateDoorphone (state, { gateId, doorphoneId }) {
      return new Promise((resolve, reject) => {
        Gate.deleteGateDoorphone(gateId, doorphoneId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    loadAllGates (state, options = {}) {
      return new Promise((resolve, reject) => {
        Gate.loadAllGates(options)
          .then(({ data }) => {
            state.commit('setGates', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getWebInfoGate (state, { id }) {
      return new Promise((resolve, reject) => {
        Gate.getWebInfoGate(id)
          .then(({ data }) => {
            state.commit('setGate', data.gate);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getSipHistory (state, id) {
      return new Promise((resolve, reject) => {
        Gate.getSipHistory(id)
          .then((response) => {
            resolve(response.data.data);
          })
          .catch(e => reject(e));
      });
    },
    exportSipHistoryCsvGate (state, id) {
      return new Promise((resolve, reject) => {
        Gate.exportSipHistoryCsvGate(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getGateInfoEdit (state, { id }) {
      return new Promise((resolve, reject) => {
        Gate.getGateInfoEdit(id)
          .then(({ data }) => {
            state.commit('setGateEdit', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newGateStore (state, params) {
      return new Promise((resolve, reject) => {
        Gate.newGateStore(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateGate (state, { id, params }) {
      return new Promise((resolve, reject) => {
        Gate.updateGate(id, params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipStatus (state, id) {
      return new Promise((resolve, reject) => {
        Gate.getSipStatus(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    openGate (state, id) {
      return new Promise((resolve, reject) => {
        Gate.openGate(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    createKeyGate (state, { id, params }) {
      return new Promise((resolve, reject) => {
        Gate.createKeyGate(id, params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    importKeysFromDevice (state, { id }) {
      return new Promise((resolve, reject) => {
        Gate.importKeysFromDevice(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportKeysToDevice (state, { id }) {
      return new Promise((resolve, reject) => {
        Gate.exportKeysToDevice(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getImportKeysGate (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Gate.getImportKeysGate(id, formData)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDestroyKeysGate (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Gate.getDestroyKeysGate(id, formData)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeGate (state, { id }) {
      return new Promise((resolve, reject) => {
        Gate.removeGate(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeKeyGate (state, { gateId, keyId }) {
      return new Promise((resolve, reject) => {
        Gate.removeKeyGate(gateId, keyId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    detachKeyGate (state, { gateId, keyId }) {
      return new Promise((resolve, reject) => {
        Gate.detachKeyGate(gateId, keyId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
